import React from 'react';
import { withPrefix } from 'gatsby';
import styles from './DownloadButton.styles';

const DownloadButton = ({ downloadImg, report, className, download = true, textButton }) => (
  <div css={styles} className={className}>
    <a className="button-link" href={withPrefix(report)} download={download}>
      <div className="button-container">
        <div className="button-container-text">
          <span>{textButton}</span>
        </div>
        {downloadImg && (
          <div className="button-container-img">
            <img src={withPrefix(downloadImg)} alt="downloadImg" />
          </div>
        )}
      </div>
    </a>
  </div>
);

export default DownloadButton;
